<ion-button (click)="clicked(icon)" *ngFor="let icon of icons;let i = index" [class]="calcStyle(i)"
            [color]="icon.selected? 'secondary': 'light'">
  <ion-icon *ngIf="icon.selected" [src]="icon.disabledSrc" size="large"></ion-icon>
  <ion-icon *ngIf="!icon.selected" [src]="icon.src" size="large"></ion-icon>
</ion-button>
